import type { NotificationsResponse } from '@eriko/shared-types';
import { apiClient } from '../lib/api';
import { ENDPOINTS } from './endpoints';

/**
 * Reviewer/admin notification feed (backlog C2): escalations + closes ready to
 * review across all clients. Items carry admin deep links (`/orgs/:orgId/...`).
 */
export async function getNotifications(): Promise<NotificationsResponse> {
  const res = await apiClient.get<NotificationsResponse>(ENDPOINTS.notifications.list);
  return res.data;
}
